import { render, staticRenderFns } from "./detail-info.vue?vue&type=template&id=57693b7b&"
import script from "./detail-info.vue?vue&type=script&lang=js&"
export * from "./detail-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports